import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-e1d279c2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  key: 0,
  class: "ml20 p20"
};
const _hoisted_2 = {
  class: "mb40 mt10 flex"
};
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return $setup.data.caIsAgree ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.data.comps, (item, index) => {
    return _openBlock(), _createElementBlock("p", {
      onClick: () => $setup.changeTabs(index),
      class: _normalizeClass(['tab pointer', index == $setup.data.tabsIndex && 'active']),
      key: index
    }, _toDisplayString(item.label), 11, _hoisted_3);
  }), 128))]), (_openBlock(), _createBlock(_resolveDynamicComponent($setup.data.comps[$setup.data.tabsIndex].name)))])) : _createCommentVNode("", true);
}